import { render, staticRenderFns } from "./RemarksPopup.vue?vue&type=template&id=75c30475&"
import script from "./RemarksPopup.vue?vue&type=script&lang=js&"
export * from "./RemarksPopup.vue?vue&type=script&lang=js&"
import style0 from "./RemarksPopup.vue?vue&type=style&index=0&id=75c30475&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports